import { PropsWithChildren, ReactNode } from 'react';

interface DialogBoxProps extends PropsWithChildren {
    label?: string;
    description?: ReactNode;
    rightDescription?: ReactNode;
    footer?: ReactNode;
    classNames?: string;
}

export default function DialogBox({
    children,
    label,
    description,
    rightDescription,
    footer,
    classNames = '',
}: DialogBoxProps) {
    return (
        <div className="w-full h-auto grid grid-cols-1 rounded-md bg-surface-1 border-[0.5px] border-line overflow-hidden">
            <div className="w-full min-h-14 p-3 flex flex-col lg:flex-row justify-between items-start lg:items-center border-b-[0.5px] gap-3 lg:gap-0 border-line">
                <div className="flex flex-col lg:flex-row justify-start items-start lg:items-center gap-0 lg:gap-2">
                    <h2 className="text-base font-bold break-words lg:text-nowrap">{label}</h2>
                    <div className="text-sm text-fg/68">{description}</div>
                </div>
                <div className="text-sm text-fg/68">{rightDescription}</div>
            </div>
            <div className={`w-full h-auto flex flex-col justify-start items-start ${classNames}`}>
                {children}
            </div>
            {footer && <div className="w-full p-4 border-t-[0.5px] border-line">{footer}</div>}
        </div>
    );
}
